const page_active = `
<li class="active"><div>{{page}}</div></li>
`;

const page_dots = `
<li><div>...</div></li>
`;

const page_clickable = `
<li><a href="#" data-page="{{page}}">{{page}}</a></li>
`;

export { page_active, page_dots, page_clickable };